import React from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../../configureStore";
import {
    ABROAD_SIGN_UP_PROP_MAP,
    LOGIN_PAGE_NAME,
    SING_UP_PAGE_NAME,
} from "../../../../../containers/RegistrationLoginPage/utils";
import {pageTrackingData, trackClickEvent} from "../../../../../utils/utils";
import {PageTrackingData} from "../../../../CTA/types";
import {getAppPlatformType} from "../../../../../utils/AppHelper";
// import {TermsAndConditionMessage} from "./Styled";

interface Props {
    onClick?: () => void;
    onTouchStart?: () => void;
    disabled?: boolean;
}
const GoogleSignupButton: React.FC<Props> = ({onClick, disabled, onTouchStart}) => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const currentPage = useSelector((state: RootStore) => state.layout.currentPageName);

    const gaTrackingData = (pageTrackingData(
        isMobile,
        ABROAD_SIGN_UP_PROP_MAP,
        currentPage === "loginPage" ? LOGIN_PAGE_NAME : SING_UP_PAGE_NAME,
        "googleSignup",
    ) as PageTrackingData).googleSignup;

    if (getAppPlatformType() == "ios") {
        return <></>;
    }

    return (
        <>
            <button
                type="button"
                onClick={() => {
                    // GA TRACKING
                    trackClickEvent(gaTrackingData.eventCategory, gaTrackingData.eventAction ?? "");
                    onClick && onClick();
                }}
                onTouchStart={() => {
                    onTouchStart && onTouchStart();
                }}
                disabled={disabled}
                className={"loginButton loginButton--google"}
            >
                Continue with Google
            </button>
        </>
    );
};

export default GoogleSignupButton;
